import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";

declare var alertify:any;
@Component({
  templateUrl:"./challengeTask.html"
})

export class ChallengeTask implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];

  ngOnInit(): void {
    this.getData();
  }



  private getData(){
    this.http.getData(API.challenge_push).then(res=>{
      this.data=res.data;
    });
  }

  private editChallenge(type:any){
    this.router.navigate(['index/challengeTask',type]);
  }



}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/badge/challengeTask.component.ts